export class UserBriefDto {
  id: number;
  userName: string;
  email: string;
}
